export const simulacaoKeys = {
  simulacao: ['simulacao'] as const,
  salvar: () => [...simulacaoKeys.simulacao, 'salvar'] as const,
  fluxoDePagamento: (ids: string[]) => [...simulacaoKeys.simulacao, 'fluxo-de-pagamento', ...ids] as const,
  listaSimulacoesRelacionadas: (idSimulacaoPrincipal: string) =>
    [...simulacaoKeys.simulacao, 'simulacoes-relacionadas', idSimulacaoPrincipal] as const,
  validarSimulacaoParaProposta: (simulacaoId: string) =>
    [...simulacaoKeys.simulacao, 'validar-simulacao', simulacaoId] as const,
  listaSimulacoesLancadas: (simulacoesIds: string[]) =>
    [...simulacaoKeys.simulacao, 'simulacoes', ...simulacoesIds] as const,
}
